import { useEffect } from "react";

const useBlockViewportScroll = shouldBlock => {
	useEffect(() => {
		const html = document.documentElement;

		const originalOverflowY = html.style.overflowY || "";
		const originalPosition = html.style.position || "";
		const originalTop = html.style.top || "";
		const originalBottom = html.style.bottom || "";
		const originalLeft = html.style.left || "";
		const originalRight = html.style.right || "";

		if (shouldBlock) {
			html.style.overflowY = "hidden";
			html.style.position = "fixed";
			html.style.top = "0";
			html.style.bottom = "0";
			html.style.left = "0";
			html.style.right = "0";
		} else {
			html.style.overflowY = originalOverflowY;
			html.style.position = originalPosition;
			html.style.top = originalTop;
			html.style.bottom = originalBottom;
			html.style.left = originalLeft;
			html.style.right = originalRight;
		}

		return () => {
			html.style.overflowY = originalOverflowY;
			html.style.position = originalPosition;
			html.style.top = originalTop;
			html.style.bottom = originalBottom;
			html.style.left = originalLeft;
			html.style.right = originalRight;
		};
	}, [shouldBlock]);
};

export default useBlockViewportScroll;
